import React from 'react'
import { Menu, withStyles } from '@material-ui/core'
import MenuItem from '@material-ui/core/MenuItem'
import SVGInline from 'react-svg-inline/src'
import infoWhite from 'media/article_list/info_white.svg'
import activityWhite from 'media/article_list/activity_white.svg'
import lessonWhite from 'media/article_list/lesson_white.svg'
import reflectionWhite from 'media/article_list/reflection_white.svg'
import { CASE_STUDY, LESSON_ACTIVITY, LESSON_LESSON, LESSON_REFLECTION } from './ArticlePointMapSegment'
import Button from '@material-ui/core/Button'

const styles = theme => ({
  pointsImage: {
    backgroundSize: 'contain'

  },
  pointButton: {
    width: 108,
    height: 108,
    position: 'absolute',
    backgroundColor: '#d80000',
    borderRadius: 90,
    zIndex: 2,
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  pointLabel: {
    backgroundColor: '#fdfdfd',
    textAlign: 'center'
  },
  pointLabelInner: {
    boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.55)',
    color: '#d80000',
    fontSize: '0.5rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    minWidth: 128,
    padding: 7,
    textAlign: 'center'
  },
  menuPopover: {},
  menuList: {
    color: 'white',
    // borderRadius: 30,
    backgroundColor: '#d80000',
    display: 'flex',
    flexDirection: 'row'
  },
  menuItem: {
    height: 'unset'
  }
})

class ImagePoints extends React.Component {
  state = {
    anchorEl: null,
    index: null,
    dimensions: null
  }

  scaleCoords (coords, dimentions) {
    const { imgWidth, imgHeight, width } = this.props
    // calculate scale based on current 'width' and the original 'imgWidth'
    const scaleW = width && imgWidth > 0 ? width / imgWidth : 1
    const scaleH = dimentions.height && imgHeight > 0 ? dimentions.height / imgHeight : 1
    const scale = scaleH > scaleW ? scaleW : scaleH
    // const scale = scaleH
    const leftOffset = (width - (imgWidth * scale)) / 2

    return [coords[0] * scale + leftOffset, coords[1] * scale, coords[2] * scale]
  }

  openButton = index => (event) => {
    this.setState({ anchorEl: event.currentTarget, index })
  }

  handleClose (section, i, event) {
    this.setState({ anchorEl: null, index: null })
    if (section) {
      this.props.handleClick(section, i, event)
    }
  }

  iconClick = (section, index, item) => (event) => {
    this.props.handleClick(section, index, event)
  }

  componentDidMount () {
    this.setState({
      dimensions: {
        width: this.container.offsetWidth,
        height: this.container.offsetHeight,
      },
    })
  }

  render () {
    let {
      src,
      classes,
      map,
      // ...props
    } = this.props
    const { anchorEl, dimensions } = this.state

    return <div className={classes.pointsImage}
                ref={el => (this.container = el)}
                style={{
                  backgroundImage: 'url("' + src + '")',
                  backgroundRepeat: 'no-repeat',
                  // backgroundSize: '100%',
                  position: 'relative',
                  backgroundPositionX: 'center',
                  // height: '80vh',
                  height: 'calc(100% - 200px)'
                }}>

      {dimensions && map.map((item, index) => {
        const scaled = this.scaleCoords([item.image_x, item.image_y, 216], dimensions)

        const info = Boolean(item.segment_menu & 1)
        const activity = Boolean(item.segment_menu & 2)
        const lesson = Boolean(item.segment_menu & 4)
        const reflection = Boolean(item.segment_menu & 8)

        return <div className={classes.pointButton} key={item.id}
                    style={{
                      left: scaled[0],
                      top: scaled[1],
                      width: scaled[2],
                      height: scaled[2]
                    }}>
          <div className={classes.pointLabel}>
            <Button className={classes.pointLabelInner} onClick={this.openButton(index)}>
              {item.button_label || item.name}
            </Button>
          </div>
          <Menu
            className={classes.menuPopover}
            id={'menuPoint' + index}
            anchorEl={anchorEl}
            keepMounted={true}

            open={Boolean(anchorEl) && index === this.state.index}
            onClose={() => this.handleClose()}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            MenuListProps={{ className: classes.menuList }}
          >
            {info && <MenuItem
              onClick={this.iconClick(CASE_STUDY, index, item)}
              className={classes.menuItem}>
              <SVGInline svg={infoWhite} className={classes.helpIcon} height='60px' width='60px' fill={'#fff'}/>
            </MenuItem>
            }
            {lesson &&
            <MenuItem
              onClick={this.iconClick(LESSON_LESSON, index, item)}
              className={classes.menuItem}>
              <SVGInline svg={lessonWhite} className={classes.helpIcon} height='60px' width='60px' fill={'#fff'}/>
            </MenuItem>
            }
            {activity && <MenuItem
              onClick={this.iconClick(LESSON_ACTIVITY, index, item)}
              className={classes.menuItem}>
              <SVGInline svg={activityWhite} className={classes.helpIcon} height='60px' width='60px' fill={'#fff'}/>
            </MenuItem>
            }
            {reflection &&
            <MenuItem
              onClick={this.iconClick(LESSON_REFLECTION, index, item)}
              className={classes.menuItem}>
              <SVGInline svg={reflectionWhite} className={classes.helpIcon} height='60px' width='60px' fill={'#fff'}/>
            </MenuItem>
            }
          </Menu>
        </div>
      })}
    </div>
  }
}

export default withStyles(styles, { withTheme: true })(
  ImagePoints
)
